import i18next from 'i18next';

i18next.addResources('es_CL', 'ShortQuestion', {
  yes: 'Si',
  no: 'No',
  receivedQuestion: '¿Recibiste el pedido completo?',
  timeQuestion: '¿Recibiste el pedido en el tiempo comprometido?',
  temperatureQuestion: '¿Recibiste el pedido con la temperatura correcta?'
});
